import { useRef } from "react";
import { Button, FormInput } from "../../../components/ui";

export default function CompanyInfoTab({
  company,
  setCompany,
  onLogoChange,
  setLogoFile,
  uploadLogoOnly,
  onSave,
  isSaving,
}) {
  const fileInputRef = useRef(null);
  const editableFields = ["name", "email", "phone", "address", "gst", "pan", "state", /* "stateCode", */ "website"];

  const handleLogoFile = async (event) => {
    const file = event.target.files?.[0];
    if (!file) return;
    if (!file.type.startsWith("image/")) return;

    // Immediately show preview in the tab
    const reader = new FileReader();
    reader.onload = () => {
      if (typeof reader.result === "string") onLogoChange(reader.result);
    };
    reader.readAsDataURL(file);
    event.target.value = "";

    // Automatically upload and save it
    if (typeof uploadLogoOnly === "function") {
      uploadLogoOnly(file);
    }
  };

  return (
    <div className="max-w-2xl space-y-6">
      <div className="mb-6">
        <h3 className="text-lg font-bold text-slate-800">Company Information</h3>
        <p className="text-sm text-slate-500">
          Manage your company profile and general contact information
        </p>
      </div>
      <div className="flex items-center gap-4 mb-6">
        <div className="w-16 h-16 bg-brand-blue rounded-2xl flex items-center justify-center overflow-hidden">
          {company.logoUrl ? (
            <img src={company.logoUrl} alt="Company Logo" className="w-full h-full object-cover" />
          ) : (
            <svg
              className="w-8 h-8 text-white"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
            >
              <polygon points="12,2 15.09,8.26 22,9.27 17,14.14 18.18,21.02 12,17.77 5.82,21.02 7,14.14 2,9.27 8.91,8.26" />
            </svg>
          )}
        </div>
        <div>
          <div className="font-bold text-brand-dark text-lg">{company.name}</div>
          <input
            ref={fileInputRef}
            type="file"
            accept="image/*"
            className="hidden"
            onChange={handleLogoFile}
          />
          <Button
            variant="secondary"
            size="xs"
            className="mt-1"
            onClick={() => fileInputRef.current?.click()}
          >
            Upload Logo
          </Button>
        </div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {editableFields.map((key) => {
          let labelStr = key.replace(/([A-Z])/g, " $1").replace(/\b\w/g, (char) => char.toUpperCase());
          if (key === "gst") labelStr = "GST";
          if (key === "pan") labelStr = "PAN";

          return (
            <FormInput
              key={key}
              field={key}
              label={labelStr}
              value={company[key] || ""}
              onChange={(e) => setCompany((prev) => ({ ...prev, [key]: e.target.value }))}
            />
          );
        })}
      </div>
      <Button variant="orange" size="md" onClick={onSave} loading={isSaving}>
        Save Changes
      </Button>
    </div>
  );
}
